<template>
  <span>
    <page-header title="Manage modules" />
    <div class="modules container">
      <span v-for="category in Object.keys(moduleData)" :key="category">
        <h4 v-if="category === 'accessOnly'" class='pt-10'>Base modules</h4>
        <h4 v-else class='pt-10'> {{ category }} </h4>
        <span
          v-for="(linkItem, index) in [...moduleData[category]]"
          :key="index + '-' + category"
          class="module-row row between pt-10 pb-10"
          :class="{activeModule: linkItem.active}"
        >
          <div class='row between w-100'>
            {{ linkItem.name }}
            <my-inputs
              :type="'checkbox'"
              :value="linkItem.active"
              :handleClick="() => handleCheckBoxChange(category, index, linkItem)"
            />
          </div>
          <p class='light em normal p-0 m-0 pt-5' v-if="linkItem.description">
            {{ linkItem.description }}
          </p>
        </span>
      </span>
      <div class='form-controls' v-show="Object.keys(hasChanges).length > 0">
        <my-inputs
            :type='"button_green"'
            :value="'Submit changes'"
            :handleClick="updateModulesClick"
        />
      </div>
    </div>
  </span>
</template>

<script>
import MyInputs from "@/myComponents/MyInputs.vue";
import PageHeader from '../../components/PageHeader.vue';
export default {
  name: "edit-site-modules",
  components: { MyInputs, PageHeader },
  data: function () {
    return {
      hasChanges: {},
      moduleData: {}
    };
  },
  methods: {
    refreshModuleData () {
      this.hasChanges = {}
      this.moduleData = { ...this.$store.getters.moduleManager.data }
    },
    async updateModulesClick () {
      await this.$store.dispatch('updateDisplayedModulesList',
        { changes: this.hasChanges, moduleData: this.moduleData })
      await this.$store.dispatch('updateAllowedModulesList', true)
      this.refreshModuleData()
    },
    handleCheckBoxChange(category, index, item) {
      let changedItem = null
      // Apply changes to item
      this.moduleData = {
        ...this.moduleData,
        [category]: [...this.moduleData[category]].map((item, i) => {
          if (i === index) {
            changedItem = {
              ...item,
              active: !item.active,
            }
            return changedItem;
          }
          return item;
        }),
      };

      // Toggle if item has been updated
      const useKey = item.id
      if (this.hasChanges[useKey]) {
        let changes = this.hasChanges
        delete changes[useKey]
        this.hasChanges = changes
      } else {
        this.hasChanges = {
          ...this.hasChanges,
          [useKey]: changedItem
        }
      } // -----
    },
  },
  mounted: function () {
    this.refreshModuleData()
  }
};
</script>

<style lang="scss">
@import "../../styles/colors.scss";
.module-row {
  border-radius: 5px;
  background-color: rgb(243, 243, 243);
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
  align-items: center;
  padding: 18px 15px 15px 15px;
  margin-bottom: 10px;
  font-weight: bold;
  color: rgb(88, 88, 88);
  border-left: 10px solid $red;
  transition: border-color .3s;
  flex-wrap: wrap;
  &.activeModule {
    border-left: 10px solid $green;
  }
}
.form-controls {
  padding-top: 10px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
